import $ from 'jquery';
import Swiper from 'swiper';

/**
 * Initialize Horizontal Tabs Swiper
 */
export function initHorizontalTabsSwiper() {
	$('.tabs-horizontal .swiper').each(function () {
		const $swiper = $(this);
		const swiperId = $swiper.attr('id');
		const $tabsContainer = $swiper.siblings('.tabs-module-wrapper');
		const uniqueId = $tabsContainer.attr('id')?.replace('tabs-layout-', '') || swiperId;
		const $swiperHeader = $tabsContainer.find('.swiper-header');
		const $paginationContainer = $tabsContainer.find('.swiper-custom-pagination');

		if (swiperId && $tabsContainer.length) {
			// Get tab titles from data attribute or parse from rendered bullets
			const tabTitles = $tabsContainer.data('tab-titles') || [];

			new Swiper(`.tabs-horizontal #${swiperId}`, {
				effect: 'fade',
				fadeEffect: {
					crossFade: true,
				},
				speed: 1,
				slidesPerView: 1,
				allowTouchMove: false,
				pagination: {
					el: `.tabs-horizontal #tabs-layout-${uniqueId} .swiper-custom-pagination`,
					clickable: true,
					renderBullet: function (index, className) {
						const tabTitle = tabTitles[index] || `Tab ${index + 1}`;
						return `<button class="tabs-module-link ${className}" role="tab" id="${uniqueId}-tab-${index}" aria-selected="${index === 0 ? 'true' : 'false'}" aria-controls="${uniqueId}-panel-${index}" tabindex="${index === 0 ? '0' : '-1'}">${tabTitle}</button>`;
					},
				},
				navigation: {
					nextEl: `.tabs-horizontal .${uniqueId}-swiper-button-next`,
					prevEl: `.tabs-horizontal .${uniqueId}-swiper-button-prev`,
				},
				breakpoints: {
					320: {
						autoHeight: true,
					},
				},
				on: {
					init: function () {
						$swiperHeader.css('transition', 'transform 0.2s ease-in-out');
						const firstBullet = $paginationContainer.find(
							'.swiper-pagination-bullet:first-child'
						)[0];
						if (firstBullet) {
							$swiperHeader.css('transform', `translateX(${-firstBullet.offsetLeft}px)`);
						}
					},
					slideChange: function () {
						const activeBullet = $paginationContainer.find('.swiper-pagination-bullet-active')[0];
						if (activeBullet) {
							$swiperHeader.css('transform', `translateX(${-activeBullet.offsetLeft}px)`);
						}
					},
				},
			});
		}
	});
}
